import { gql } from "@apollo/client";

export const GoalOverviewRelatedEntityGoalFragment = gql`
  fragment GoalOverviewRelatedEntityGoalFragment on GoalArtifactNode {
    id
    title
    artifactType
    scope
    state
    status
    progress
    isStale
    canUpdate {
      permission
    }
    goalVisibility
    dueDate
    startDate
    startValue
    targetValue
    progressType
    currentValue
    created
    canDelete {
      permission
    }
    ownersList {
      id
      name
      avatar
    }
    teamsList {
      id
      title
    }
    activities(first: 1, activityType: goal_checkin) {
      edges {
        node {
          id
          created
        }
      }
    }
  }
`;

export const getGoalOverviewRelatedEntitiesQuery = gql`
  ${GoalOverviewRelatedEntityGoalFragment}
  query getGoalOverviewRelatedEntitiesQuery(
    $goalOwners: [Int!]
    $goalTeams: [Int!]
    $goalDueBetweenDates: [Date]!
    $hasOwners: Boolean!
    $hasTeams: Boolean!
  ) {
    ownerGoals: artifacts(
      artifactType: goal
      goalOwners: $goalOwners
      goalDueBetweenDates: $goalDueBetweenDates
    ) @include(if: $hasOwners) {
      edges {
        node {
          id
          ... on GoalArtifactNode {
            ...GoalOverviewRelatedEntityGoalFragment
          }
        }
      }
    }
    teamGoals: artifacts(
      artifactType: goal
      goalScope: team
      goalTeams: $goalTeams
      goalDueBetweenDates: $goalDueBetweenDates
    ) @include(if: $hasTeams) {
      edges {
        node {
          id
          ... on GoalArtifactNode {
            ...GoalOverviewRelatedEntityGoalFragment
          }
        }
      }
    }
  }
`;

// Keep default export for backwards compatibility during migration
export default getGoalOverviewRelatedEntitiesQuery;
